import User from '../user';
import { notify } from 'reapop';


import retrieveUser from 'actions/authentication/retrieve';

/**
 * Create the action
 */

const { thunk, request, success, error } = User.update((data, fetch) => {

    // Prepare request
    let formData = new FormData();

    const fields = Object.keys(data);

    fields.map((field) => {
        formData.append(field, data[field]);
    });

    formData.append('_method', 'PUT');

    return fetch.post(`/users/${data.id}`, formData);
}, {
    onSuccess: function(result, dispatch) {
        dispatch(notify({
            message: 'Account geüpdatet',
            dismissible: true,
            status: 'success',
            position: 'tc'
        }));
        dispatch(retrieveUser());
    },
    onError: function(error, dispatch) {
        dispatch(notify({
            message: 'Er is iets mis gegaan',
            dismissible: true,
            status: 'error',
            position: 'tc'
        }));
        dispatch(retrieveUser());
    },
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
